export const SET_GUEST = 'AUTH/SET_GUEST'
export const SET_VERIFIED = 'AUTH/SET_VERIFIED'
export const SET_TOKEN = 'AUTH/SET_TOKEN'
export const SET_WAITING_CODE = 'AUTH/SET_WAITING_CODE'
export const SET_CODE_ERROR = 'AUTH/SET_CODE_ERROR'
export const SET_HAS_PASSWORD = 'AUTH/SET_HAS_PASSWORD'
export const RESET_STATE = 'AUTH/RESET_STATE'
export const SET_WAITING_RESET_CODE = 'AUTH/SET_WAITING_RESET_CODE'

